export default "__VITE_ASSET__Cn2F$Ym6__"